import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(['DaDataCountryUrl', 'DaDataToken'])
  },
  methods: {
    async suggestCountry(val) {
      let url = this.DaDataCountryUrl,
        token = this.DaDataToken,
        query = val

      let options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({ query, count: 5 })
      }

      let sg = await(fetch(url, options)
        .then(response => response.json())
        .then(res => { return res.suggestions.map(el => el.value) })
        .catch(() => []))

      return sg
    }
  }
}